<template>
  <div class="container">
    <a-breadcrumb>
      <a-breadcrumb-item>
        <router-link :to="{ name: 'List' }">
          抽奖活动管理
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>活动数据</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="title">
      <h3>活动名称</h3>
      <span>活动类型：转盘</span>
    </div>
    <div class="filter">
      <div class="terminal">
        <span>终端</span>
        <a-select
          v-model:value="terminalId"
          placeholder="请选择"
          :options="options"
          @change="getActiveData"
          class="w200"
        >
        </a-select>
      </div>
      <a-space>
        <a-button @click="reset">重置</a-button>
        <a-button type="primary" @click="getActiveData">查询</a-button>
      </a-space>
    </div>
    <a-row>
      <a-col :span="8">
        <a-statistic title="参与总人数" :value="dataObj?.headcount" />
      </a-col>
      <a-col :span="8">
        <a-statistic title="参与总次数" :value="dataObj?.totalNumber" />
      </a-col>
    </a-row>
    <a-table
      :dataSource="dataObj?.lotteryPrizeDTOList"
      :columns="columns"
      :pagination="false"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'action'">
          <a-button
            type="link"
            style="padding:0"
            size="small"
            @click="handleDetail(record.id)"
            >发放明细</a-button
          >
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
import { onMounted, reactive, toRefs } from 'vue'
import { lottery_activity_attendData } from '@/server/modules/8199.js'
import { common_querySiteInfo_get } from '@/server/modules/3426.js'
import { useRoute, useRouter } from 'vue-router'
import { message } from 'ant-design-vue'

export default {
  setup() {
    const route = useRoute()
    const router = useRouter()
    const state = reactive({
      terminalId: '',
      columns: [
        {
          title: '奖项',
          dataIndex: 'prizeName',
          key: 'prizeName',
          align: 'left'
        },
        {
          title: '获奖次数',
          dataIndex: 'awardsNum',
          key: 'awardsNum',
          align: 'right'
        },
        {
          title: '今日剩余库存',
          dataIndex: 'remainingOneDayInventory',
          key: 'remainingOneDayInventory',
          align: 'right',
          customRender({ text }) {
            return text === -1 ? '不限' : text
          }
        },
        {
          title: '剩余总库存',
          dataIndex: 'remainingTotalInventory',
          key: 'remainingTotalInventory',
          align: 'right',
          customRender({ text }) {
            return text === -1 ? '不限' : text
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 80,
          alias: 'left'
        }
      ],
      dataObj: {},
      options: [],
      reset() {
        state.terminalId = ''
        state.getActiveData()
      },
      handleDetail(id) {
        const params = route.query
        router.push({ name: 'DistributionDetails', query: { id, ...params } })
      },
      async queryData() {
        try {
          const { success, data } = await common_querySiteInfo_get()
          if (success) {
            state.options = data[4].map(e => ({
              label: e.name,
              value: e.id
            }))
            state.options.unshift({ label: '全部', value: '' })
          }
        } catch (error) {
          console.log('error', error)
        }
      },

      async getActiveData() {
        try {
          const params = {
            activityId: route.query?.activityId,
            terminalId: state.terminalId
          }
          let res = await lottery_activity_attendData(params)
          if (res.success) {
            state.dataObj = res.data
          } else {
            message.error(res.retInfo)
          }
        } catch (error) {
          console.log('error', error)
        }
      }
    })

    onMounted(() => {
      state.queryData()
      state.getActiveData()
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  background-color: #fff;
  padding: 16px 24px 24px 24px;
  margin: 16px;
  .title {
    margin: 16px 0;
    h3 {
      margin-bottom: 10px;
    }
  }
  .filter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 24px 0;
    .terminal {
      span {
        margin-right: 8px;
      }
    }
  }
}
</style>
